export default function ArraySubTableSourceFirestore({ children }: { children?: React.ReactNode }) {
  return children || null;
}
